import * as React from 'react'

import { cn } from '@/utils/cn'

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('text-sm font-semibold text-secondary-700', className)}
      {...props}
    />
  ),
)

Label.displayName = 'Label'

